import { createActionName } from "../../../utility"

export const reducerName = "embeds"

export const EMBED = createActionName(reducerName, "EMBED")
export const EMBEDS = createActionName(reducerName, "EMBEDS")
